// @flow
import axios from 'lib/defaultClient';
import queryString from 'query-string';

export type WritePartnerPayload = {
  title: string,
  body: string,
  is_temp: boolean,
  tags: Array<string>,
  categories: Array<string>,
  thumbnail: ?string,
  url_slug?: ?string,
  is_private: boolean,
  series_id: ?string,
};

export const writePartner = (payload: WritePartnerPayload) => axios.post('/partners', payload);

export type UpdatePartnerPayload = {
  id: string,
  title: string,
  body: string,
  tags: Array<string>,
  categories: Array<string>,
  url_slug?: ?string,
  thumbnail?: string,
  is_temp: boolean,
  thumbnail: ?string,
  is_private: boolean,
  series_id: ?string,
};

export const updatePartner = ({ id, ...payload }: UpdatePartnerPayload) =>
  axios.patch(`/partners/${id}`, payload);

export type ReadPartnerPayload = {
  username: string,
  urlSlug: string,
};

export const readPartner = ({ username, urlSlug }: ReadPartnerPayload) =>
  axios.get(`/partners/@${username}/${urlSlug}`);

export type UploadImagePayload = {
  file: any,
  partnerId: string,
  onUploadProgress(): void,
};

export const uploadImage = ({ file, partnerId, onUploadProgress }: UploadImagePayload) => {
  const data = new FormData();
  data.append('partner_id', partnerId);
  data.append('image', file);
  return axios.post('/files/upload/partner', data, {
    onUploadProgress,
  });
};

export type TempSavePayload = {
  title: string,
  body: string,
  partnerId: string,
};

export const tempSave = ({ partnerId, title, body }: TempSavePayload) =>
  axios.post(`/partners/${partnerId}/saves`, { title, body });

export type CreateUploadUrlPayload = { partnerId: string, filename: string };
export const createUploadUrl = ({ partnerId, filename }: CreateUploadUrlPayload) => {
  return axios.post('/files/create-url/partner-image', { partner_id: partnerId, filename });
};

/* LISTING RELATED... */
export const getPublicPartners = (cursor: ?string, category: ?string, sort: ?string) => {
  return axios.get('/partners/public', {
    params: {
      cursor,
      category,
      sort,
    },
  });
};

export const getTrendingPartners = (offset: ?number) => {
  const query = offset ? `?offset=${offset}` : '';
  return axios.get(`/partners/trending${query}`);
};

export type GetUserPartnersPayload = {
  username: string,
  tag?: string,
  cursor?: string,
};

export const getUserPartners = ({ username, cursor, tag }: GetUserPartnersPayload) => {
  const query = queryString.stringify({
    cursor,
    tag,
  });
  return axios.get(`/partners/@${username}?${query}`);
};

export type GetPublicPartnersByCategoryPayload = {
  category: string,
  cursor?: string,
  sort?: string,
};

export const getPublicPartnersByCategory = (payload: GetPublicPartnersByCategoryPayload) => {
  const query = queryString.stringify(payload);
  return axios.get(`/partners/public?${query}`);
};

export type GetPublicPartnersByTagPayload = {
  tag: string,
  cursor?: string,
};

export const getPublicPartnersByTag = (payload: GetPublicPartnersByTagPayload) => {
  const query = queryString.stringify(payload);
  return axios.get(`/partners/public?${query}`);
};

export type GetTempPartnersPayload = {
  username: string,
  cursor?: string,
};

export const getTempPartners = ({ username, cursor }: GetTempPartnersPayload) => {
  const query = queryString.stringify({
    is_temp: true,
    cursor,
  });
  return axios.get(`/partners/@${username}?${query}`);
};

export const deletePartner = (partnerId: string) => {
  return axios.delete(`/partners/${partnerId}`);
};

export const getPartnerById = (partnerId: string) => {
  return axios.get(`/partners/${partnerId}`);
};

export const getPartnerSequences = (partnerId: string) => {
  return axios.get(`/partners/sequences?partner_id=${partnerId}`);
};



// WEBPACK FOOTER //
// ./src/lib/api/partners/index.js